import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = {
  class: "column no-wrap items-center",
  style: {"position":"absolute","top":"5px","left":"5px","z-index":"3"}
}
const _hoisted_3 = {
  class: "btn btn-sm btn-primary ml-1",
  style: {"cursor":"pointer"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "full-width" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mark text-center small" }, " Если ТС не эксплуатировалось или температура ДВС не достигла диапазона для замера давления, то на графике за этот период не будет информации ", -1)
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"position":"absolute","top":"0","left":"0","width":"100%","height":"100%","padding":"20px"}
}
const _hoisted_8 = {
  key: 0,
  src: "images/notifications/error.svg",
  alt: "Error",
  style: {"width":"50px","height":"50px"}
}
const _hoisted_9 = {
  class: "mt-2 text-teal",
  style: {"font-size":"1.1em"}
}

import { computed, ref } from 'vue';

import MyModal from '@/App/Components/MyModal.vue';
import UiTitle from '../UiTitle.vue';
import PressureTable, { Filters } from '../PressureTable.vue';
import SpinLoader from '@/App/Components/SpinLoader.vue';

import type {
  ObjectPressure,
  ReportCalculated,
} from '@/Template/OilPressure/OilPressure';

import { FORMAT_TYPES, DAYS_COLUMNS, DETAIL_COLUMNS } from '../Columns';
import OilPressureDetailChart, {
  Props as PressureChartProps,
} from './OilPressureDetailChart.vue';

import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';

export type Props = {
  modelValue: boolean;
  status: {
    label: string;
    error: boolean;
    request: boolean;
  };
  retryHandler: null | (() => void);
  label: string;
  interval: string;
  detailKey: 'detail' | 'days';
  motoIndex: PressureChartProps['motoIndex'];
  temperatureIndex: PressureChartProps['temperatureIndex'];
  pressureKey: PressureChartProps['pressureKey'];
  filters?: Filters;
  templateName: string;
  data: null | ReportCalculated;
};

export type Emit = {
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OilPressureDetailPopup',
  props: {
    modelValue: { type: Boolean },
    status: null,
    retryHandler: null,
    label: null,
    interval: null,
    detailKey: null,
    motoIndex: null,
    temperatureIndex: null,
    pressureKey: null,
    filters: null,
    templateName: null,
    data: null
  },
  emits: ["update:modelValue", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  status: {
    label: string;
    error: boolean;
    request: boolean;
  };
  retryHandler: null | (() => void);
  label: string;
  interval: string;
  detailKey: 'detail' | 'days';
  motoIndex: PressureChartProps['motoIndex'];
  temperatureIndex: PressureChartProps['temperatureIndex'];
  pressureKey: PressureChartProps['pressureKey'];
  filters?: Filters;
  templateName: string;
  data: null | ReportCalculated;
}




const card = ref<null | HTMLElement>(null);
const header = ref<null | HTMLElement>(null);

const showTable = ref(false);

const layoutModel = computed({
  get: () => props.modelValue,
  set: (n) => {
    if (!n) {
      showTable.value = false;
    }
    emit('update:modelValue', n);
  },
});

const tableMaxHeight = computed(() => {
  const paddingBottomPX = 5;
  if (!!card.value && !!header.value) {
    const cardHeight = card.value.clientHeight;
    const headerHeight = header.value.clientHeight;

    return cardHeight - headerHeight - paddingBottomPX + 'px';
  } else {
    return '100%';
  }
});

function tryRetry() {
  if (!!props.retryHandler) {
    props.retryHandler();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(layoutModel))
      ? (_openBlock(), _createBlock(MyModal, {
          key: 0,
          class: "d-flex",
          style: {"height":"max-content"},
          onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('close')))
        }, {
          body: _withCtx(() => [
            _createElementVNode("div", {
              ref_key: "card",
              ref: card,
              class: "full-height"
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  ref_key: "header",
                  ref: header,
                  class: "relative-position row justify-center no-wrap full-width"
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showTable).value = $event)),
                        type: "checkbox",
                        "checked-icon": "table_chart",
                        "unchecked-icon": "show_chart",
                        color: "green",
                        hidden: ""
                      }, null, 512), [
                        [_vModelCheckbox, showTable.value]
                      ]),
                      _createTextVNode(" " + _toDisplayString(`Показать ${!showTable.value ? 'таблицу' : 'график'}`), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "not-print float-left btn btn-sm btn-primary",
                      disabled: !showTable.value,
                      onClick: _cache[1] || (_cache[1] = 
                    (e) =>
                      showTable.value &&
                      _unref(html_to_excel_helper).export(
                        e.target,
                        'oil-pressure-detail-template-content',
                        __props.label,
                        'landscape',
                      )
                  )
                    }, " Экспорт в EXCEL ", 8, _hoisted_4)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(UiTitle, {
                      title: __props.label,
                      interval: __props.interval,
                      "subtitle-part": 
                    (__props.pressureKey === 'e'
                      ? 'температура охлаждающей жидкости ДВС. '
                      : 'температура масла ДВС. ') +
                    _unref(DETAIL_COLUMNS)(__props.motoIndex, __props.detailKey)[1]?.label
                  
                    }, null, 8, ["title", "interval", "subtitle-part"])
                  ]),
                  _createElementVNode("img", {
                    class: "close",
                    style: {"position":"absolute","top":"0","right":"5px","z-index":"3"},
                    src: "/images/close.png",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
                  })
                ], 512),
                (
                props.data !== null &&
                !!props.data.objects[0].pressure[__props.detailKey]
              )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "temlate-report py-none",
                      id: "oil-pressure-detail-template-content",
                      style: _normalizeStyle([{"max-width":"100%","width":"100%","overflow":"scroll"}, { maxHeight: _unref(tableMaxHeight) }])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["not-excel", [showTable.value && 'd-none']])
                      }, [
                        _hoisted_6,
                        _createVNode(OilPressureDetailChart, {
                          rows: props.data.objects[0].pressure[__props.detailKey],
                          "moto-index": props.motoIndex,
                          "temperature-index": props.temperatureIndex,
                          "detail-key": props.detailKey,
                          "pressure-key": props.pressureKey
                        }, null, 8, ["rows", "moto-index", "temperature-index", "detail-key", "pressure-key"])
                      ], 2),
                      (showTable.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(UiTitle, {
                              hidden: "",
                              title: __props.label,
                              interval: __props.interval,
                              "subtitle-part": 
                    (__props.pressureKey === 'e'
                      ? 'температура охлаждающей жидкости ДВС. '
                      : 'температура масла ДВС. ') +
                    _unref(DETAIL_COLUMNS)(__props.motoIndex, __props.detailKey)[1]?.label
                  
                            }, null, 8, ["title", "interval", "subtitle-part"]),
                            _createVNode(PressureTable, {
                              "format-types": _unref(FORMAT_TYPES),
                              columns: _unref(DETAIL_COLUMNS)(props.motoIndex, __props.detailKey),
                              objects: props.data.objects,
                              handler: (obj) => obj.pressure[__props.detailKey],
                              "pressure-key": props.pressureKey,
                              templateName: props.templateName,
                              filters: props.filters
                            }, null, 8, ["format-types", "columns", "objects", "handler", "pressure-key", "templateName", "filters"])
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 4))
                  : _createCommentVNode("", true)
              ]),
              (__props.status.request)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      (__props.status.error)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                        : _createCommentVNode("", true),
                      (!__props.status.error)
                        ? (_openBlock(), _createBlock(SpinLoader, {
                            key: 1,
                            width: 50,
                            height: 50
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(__props.status.label), 1),
                    (__props.status.error)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-primary mt-2",
                          onClick: tryRetry
                        }, " Повторить запрос "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})